<section class="amvara-video">
  <div class="video__filter"></div>
  <div class="video__content">
    @if (!mobileOrDesktop) {
      <div class="video__content__row video__content__row_dialog">
        <div class="video__content__row__container">
          <a href="https://www.youtube.com/watch?v=KXX4G9h2PS0" target="_blank" [attr.aria-label]="'amvaraVideo.video1AriaLabel' | transloco">
            <div class="video__content__row__container__div">
              <p class="video__content__row__container__div__p">
                {{ 'amvaraVideo.video1Title' | transloco }}
              </p>
              <p>
                <span>{{ 'amvaraVideo.video1Year' | transloco }}</span>
              </p>
            </div>
            <div class="video__content__row__container__img">
              <img src="assets/img/amvara_web_icon_video_1.jpg" [attr.alt]="'alts.ibmCognosAnalytics' | transloco" class="video__content__row__img">
            </div>
          </a>
        </div>
        <div class="video__content__row__container">
          <a href="https://www.youtube.com/watch?v=r_-xSZhEb-o" target="_blank" [attr.aria-label]="'amvaraVideo.video2AriaLabel' | transloco">
            <div class="video__content__row__container__div">
              <p class="video__content__row__container__div__p">
                {{ 'amvaraVideo.video2Title' | transloco }}
              </p>
              <p>
                {{ 'amvaraVideo.video2Year' | transloco }}
              </p>
            </div>
            <div class="video__content__row__container__img">
              <img src="assets/img/amvara_web_icon_video_2.jpg" [attr.alt]="'alts.ibmCognosAnalytics' | transloco" class="video__content__row__img">
            </div>
          </a>
        </div>
        <div class="video__content__row__container">
          <a href="https://www.youtube.com/watch?v=2_u26haJfPc" target="_blank" [attr.aria-label]="'amvaraVideo.video3AriaLabel' | transloco">
            <div class="video__content__row__container__div">
              <p class="video__content__row__container__div__p">
                {{ 'amvaraVideo.video3Title' | transloco }}
              </p>
              <p>
                {{ 'amvaraVideo.video3Year' | transloco }}
              </p>
            </div>
            <div class="video__content__row__container__img">
              <img src="assets/img/amvara_web_icon_video_3.jpg" [attr.alt]="'alts.ibmCognosAnalytics' | transloco" class="video__content__row__img">
            </div>
          </a>
        </div>
      </div>
    }
    @if (mobileOrDesktop) {
      <div class="video__content__row video__content__row_dialog">
        <div class="video__content__row__container">
          <a href="https://www.youtube.com/watch?v=KXX4G9h2PS0" target="_blank" [attr.aria-label]="'amvaraVideo.video1AriaLabel' | transloco">
            <div class="video__content__row__container__img__mobile">
              <img src="assets/img/amvara_web_icon_video_1.jpg" [attr.alt]="'alts.ibmCognosAnalytics' | transloco" class="video__content__row__img__mobile">
            </div>
            <div class="video__content__row__container__p__mobile">
              <p>
                {{ 'amvaraVideo.video1Title' | transloco }}
              </p>
              <p>
                <span>{{ 'amvaraVideo.video1Year' | transloco }}</span>
              </p>
            </div>
          </a>
        </div>
        <div class="video__content__row__container">
          <a href="https://www.youtube.com/watch?v=r_-xSZhEb-o" target="_blank" [attr.aria-label]="'amvaraVideo.video2AriaLabel' | transloco">
            <div class="video__content__row__container__img__mobile">
              <img src="assets/img/amvara_web_icon_video_2.jpg" [attr.alt]="'alts.ibmCognosAnalytics' | transloco" class="video__content__row__img__mobile">
            </div>
            <div class="video__content__row__container__p__mobile">
              <p>
                {{ 'amvaraVideo.video2Title' | transloco }}
              </p>
              <p>
                {{ 'amvaraVideo.video2Year' | transloco }}
              </p>
            </div>
          </a>
        </div>
        <div class="video__content__row__container">
          <a href="https://www.youtube.com/watch?v=2_u26haJfPc" target="_blank" [attr.aria-label]="'amvaraVideo.video3AriaLabel' | transloco">
            <div class="video__content__row__container__img__mobile">
              <img src="assets/img/amvara_web_icon_video_3.jpg" [attr.alt]="'alts.ibmCognosAnalytics' | transloco" class="video__content__row__img__mobile">
            </div>
            <div class="video__content__row__container__p__mobile">
              <p>
                {{ 'amvaraVideo.video3Title' | transloco }}
              </p>
              <p>
                {{ 'amvaraVideo.video3Year' | transloco }}
              </p>
            </div>
          </a>
        </div>
      </div>
    }
  </div>
</section>
